'use client';

import { createContext, useContext, useEffect, useState } from 'react';
import { usePathname, useSearchParams } from 'next/navigation';

const StoreRouterPath = createContext({ prevPath: '', currentPath: '' });

export function StoreRouterPathProvider({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  const [pathHistory, setPathHistory] = useState({ prevPath: '', currentPath: '' });

  useEffect(() => {
    const storage = window.sessionStorage;
    if (!storage) return;

    const currentPath = searchParams.size ? `${pathname}?${searchParams.toString()}` : pathname;
    const prevPath = storage.getItem('currentPath');
    if (currentPath === prevPath) return;

    storage.setItem('prevPath', prevPath ?? '');
    storage.setItem('currentPath', currentPath);

    setPathHistory({
      prevPath: window.sessionStorage.getItem('prevPath') ?? '',
      currentPath: window.sessionStorage.getItem('currentPath') ?? '',
    });
  }, [pathname, searchParams]);

  return <StoreRouterPath value={pathHistory}>{children}</StoreRouterPath>;
}

export function usePathHistory() {
  return useContext(StoreRouterPath);
}
